import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { useGetAuthenticatedUser } from '../../../Flux/Selector/index.js'
import { canUseSpin } from '../../../Model/index.js'

/** The SPIN pages are open to everyone; SPINs inside one's own data are an INSIGHT feature. */
export const SpinInsightNudge = () => {
  const user = useGetAuthenticatedUser()
  if (!user || canUseSpin(user)) return null
  return (
    <div role="status" data-testid="spin-insight-nudge" className="alert alert-info my-2 py-2 text-sm">
      <InformationCircleIcon className="h-4 w-4" />
      <span>
        You can look up any SPIN here. Seeing the SPINs in your own orders and projects needs spcfy INSIGHT — your own licence, or a
        processing lab sharing its licence for that order.
      </span>
    </div>
  )
}
